import React from 'react';
import PropTypes from 'prop-types';
import { usePopulate } from 'api/APIHooks';
import authorizationShape from '../authorizationShape';
import AuthorizationHistoryLineItem from './AuthorizationHistoryLineItem';
import RequestedAuthorizationFields from './RequestedAuthorizationFields';

const RejectedAuthorizationFields = ({ authorization }) => {
  usePopulate(
    'service_authorization_denial_reason',
    'service_authorization_denial_reason',
    authorization,
    {
      queryConfig: {
        placeholderData: undefined,
      },
    },
  );

  return (
    <>
      <AuthorizationHistoryLineItem field="Rejection Reason">
        {authorization.service_authorization_denial_reason?.display_name || 'N/A'}
      </AuthorizationHistoryLineItem>
      <AuthorizationHistoryLineItem field="Notes">
        {authorization.adjudicator_note ? (
          <div className="whitespace-pre-line">{authorization.adjudicator_note}</div>
        ) : (
          'N/A'
        )}
      </AuthorizationHistoryLineItem>

      <div className="col-span-4 border-t border-dark-border-blue my-1" aria-hidden="true" />

      <RequestedAuthorizationFields
        authorization={authorization}
        notesContent={authorization.update_request_note}
      />
    </>
  );
};

RejectedAuthorizationFields.propTypes = {
  authorization: PropTypes.shape(authorizationShape).isRequired,
};

export default RejectedAuthorizationFields;
